<div class="services-panel">
  <div class="services-panel__filter">
    <mat-expansion-panel [expanded]="true" class="filter">
      <mat-expansion-panel-header>
        <div class="filter__header">
          <span class="filter__header__title"
            >Búsqueda por Órden de Servicio</span
          >
        </div>
      </mat-expansion-panel-header>

      <form [formGroup]="searchDataForm" class="filter__form">
        <mat-form-field appearance="outline" class="mat-form-field--custom">
          <mat-label class="mat-label--custom">Órden de servicio</mat-label>
          <input matInput formControlName="searchValue" #searchInput />
        </mat-form-field>
        <button
          class="filter__form__button"
          mat-flat-button
          color="primary"
          (click)="searchClientData()"
        >
          <span>BUSCAR</span>
        </button>
      </form>
    </mat-expansion-panel>
  </div>
  @if (serviceOrderService.isIdle()){
  <div class="bg-white rounded-md">
    <div class="no-data-container max-w-[400px] mx-auto">
      <app-horus-message-general
        nameIcon="noDataMessageIcon"
        btnAction="LIMPIAR VALORES"
        (action)="clearFilters()"
        size="M">
        <span style="color:#F6D44D; font-size: 14px; line-height: 25px;">Todavía no hay nada por aquí</span><br />
        <span style="font-weight: 400; margin-top: 5px;" class="text-[18px]">Aún no tenemos información sobre <strong>&lt;servicios&gt;</strong> en relación a tu búsqueda. Prueba usando otros valores o buscando por Orden de Servicio.</span>
      </app-horus-message-general>
    </div>
  </div>
  } @else if (serviceOrderService.error()) {
  <div class="bg-white rounded-md">
    <div class="no-data-container max-w-[400px] mx-auto">
      <app-horus-message-general
        nameIcon="errorMessageIcon"
        btnAction="INTENTAR NUEVAMENTE"
        (action)="(null)"
        size="M"
      >
        <span style="color: #f14b26; font-size: 14px; line-height: 25px"
          >Lo sentimos</span
        ><br />
        Hubo un <strong>error al intentar cargar</strong> la data del Servicio.
      </app-horus-message-general>
    </div>
  </div>
  } @else if (serviceOrderService.showNoResults()) {
  <div class="bg-white rounded-md">
    <div class="no-data-container max-w-[400px] mx-auto">
      <app-horus-message-general
        nameIcon="noDataMessageIcon"
        btnAction="LIMPIAR VALORES"
        (action)="clearFilters()"
        size="M"
      >
        <span style="color: #f6d44d; font-size: 14px; line-height: 25px"
          >Todavía no hay nada por aquí</span
        ><br />
        <span style="font-weight: 400; margin-top: 5px" class="text-[18px]"
          >Aún no tenemos información sobre
          <strong>&lt;servicios&gt;</strong> en relación a tu búsqueda. Prueba
          usando otros valores o buscando por Orden de Servicio.</span
        >
      </app-horus-message-general>
    </div>
  </div>
  } @else if (serviceOrderService.isLoader()) {
  <div class="services-panel__message">
    <app-horus-loading></app-horus-loading>
  </div>
  } @else if (serviceOrderService.isLoaded()) {
  <div class="services-panel__content">
    <div class="services-panel__content__list">
      <span class="list__title">Servicios</span>

      <!-- Mensaje de error o vacío -->
      <app-horus-message-general
        *ngIf="serviceOrderService.showNoResults()"
        nameIcon="errorMessageIcon"
      >
        No se encontraron servicios para el código ingresado.
      </app-horus-message-general>

      <!-- Tabla de resultados -->
      <table
        mat-table
        [dataSource]="paginatedData()"
        class="list__table mat-elevation-z1"
        multiTemplateDataRows
      >
        <ng-container matColumnDef="os">
          <th mat-header-cell *matHeaderCellDef>N° de orden</th>
          <td mat-cell *matCellDef="let row">{{ row.osId }}</td>
        </ng-container>
        <ng-container matColumnDef="fechaRegistro">
          <th mat-header-cell *matHeaderCellDef>Registro</th>
          <td mat-cell *matCellDef="let row">
            {{ row.fechaRegistro | date : "dd/MM/yy" }}
          </td>
        </ng-container>
        <ng-container matColumnDef="fechaEstimada">
          <th mat-header-cell *matHeaderCellDef>Fecha estimada</th>
          <td mat-cell *matCellDef="let row">
            {{ row.fechaEstimada | date : "dd/MM/yy" }}
          </td>
        </ng-container>
        <ng-container matColumnDef="acciones">
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let row">
            <div class="list__table__actions">
              <button
                mat-icon-button
                (click)="onServiceRowClick(row)"
              >
                <svg width="15" height="16" viewBox="0 0 15 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M5.75108 4.44458L4.91553 5.28014L7.6296 8.00014L4.91553 10.7201L5.75108 11.5557L9.30664 8.00014L5.75108 4.44458Z" fill="#26A2F1"/>
                </svg>
              </button>
            </div>
          </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="columns"></tr>
        <tr
          mat-row
          *matRowDef="let row; columns: columns"
          (click)="onServiceRowClick(row)"
          [class.selected-row]="serviceOrderService.selectedService()?.osId === row.osId"
          class="clickable-row">
        </tr>
      </table>

      <!-- Pagination Component -->
      <app-od-pagination
        *ngIf="totalItems() > 0"
        [totalItems]="totalItems()"
        [itemsPerPage]="itemsPerPage"
        [page]="currentPage()"
        (pageChange)="onPageChange($event)"
        style="margin-top: 16px"
      >
      </app-od-pagination>
    </div>

    <div class="services-panel__content__detail">
      @if (serviceOrderService.selectedService()) {
        <app-service-detail-tab></app-service-detail-tab>
      }
    </div>
  </div>
  }
</div>
